import createLinesFill from '../anims/LinesFill'

export default class LinesFill {
  constructor() {
    setTimeout(() => {
      this._getElems()
      this._linesFill()
    }, 1000)
  }

  _getElems() {
    this.text = document.querySelectorAll('[data-lines-fill]')
  }

  _linesFill() {
    if (this.text) {
      this.text.forEach((text) => {
        createLinesFill(text)
      })
    }
  }
}
